<template>
  <div class="dr-col-12">
    <p class="heading-h3 font-secondary_bold text-center mb-15">{{ localize.KZ_DELIVERY_TITLE }}</p>
    <p class="dr-text__big c-brown_light text-center max-w-550">{{ localize.KZ_DELIVERY_DESCRIPTION }}</p>
    <div class="dr-form-group max-w-430">
      <p class="dr-form-label dr-form-label_new dr-text__small">{{ localize.KZ_DELIVERY_LOCATION_TITLE }}</p>
      <div class="dr-form-control">
        <jquery-dadata :default-value="defaultCity" :placeholder="localize.KZ_DELIVERY_LOCATION_PLACEHOLDER" @select="handleDadataSelect"></jquery-dadata>
      </div>
    </div>
    <div class="dr-t_flex dr-t_6-3-3 mt-30">
      <div class="dr-t__head bg-gray__extralight">
        <div class="dr-t__row">
          <div class="dr-t__cell">
            <div class="dr-t__cell_inner">{{ localize.KZ_DELIVERY_TYPE }}</div>
          </div>
          <div class="dr-t__cell">
            <div class="dr-t__cell_inner">{{ localize.KZ_DELIVERY_PERIOD }}</div>
          </div>
          <div class="dr-t__cell">
            <div class="dr-t__cell_inner">{{ localize.KZ_DELIVERY_PRICE }}</div>
          </div>
        </div>
      </div>
      <div class="dr-t__body" v-if="calculatedDeliveries">
        <delivery-item
            v-for="delivery in calculatedDeliveries"
            :method-title="delivery.title"
            :price="delivery.price.toString()"
            :period-from="delivery.period_from"
            :period-to="delivery.period_to"
            :custom-period="delivery.custom_period"
        ></delivery-item>
      </div>
    </div>
    <p class="c-brown_light dr-text__normal mt-30 mb-0">{{ localize.KZ_DELIVERY_NOTE }}</p>

    <div class="bg-gray__extralight w-100 panel-notice mt-30">
      <p class="c-black dr-text__normal" v-html="remoteNote"></p>
    </div>
  </div>
</template>

<script>
import { JqueryDadata } from 'kanzler.components';
import DeliveryItem from "./delivery-item.vue";

export default {
  props: {
    productId: String,
    defaultCity: String,
  },
  data: (vm) => ({
    currentLocationCode: cityCodes[vm.defaultCity],
    calculatedDeliveries: undefined,
  }),
  computed: {
    localize() {
      return BX.Vue.getFilteredPhrases('KZ_DELIVERY_');
    },
    remoteNote() {
      return BX.message('KZ_REMOTE_DELIVERY_NOTE');
    },
  },
  mounted() {
    this.refresh();
  },
  methods: {
    handleDadataSelect(event) {
      if (event.data.postal_code) {
        this.findLocation(event.data.postal_code, event.data.region, event.data.city)
          .then(response => {
            this.currentLocationCode = !response.success ? undefined : response.data.locationCode;
          })
          .catch(() => {
            this.currentLocationCode = undefined;
          })
          .finally(() => {
            this.refresh();
          });
      }
    },

    findLocation(zipCode, region, city) {
      return fetch(`/local/ajax/getLocationByZip.php?zip_code=${zipCode}&region=${region}&city=${city}`)
          .then(response => response.json())
    },

    refresh() {
      this.fetchDeliveryPrice().then((deliveryCalculationResult) => {
        this.calculatedDeliveries = deliveryCalculationResult;
      });
    },

    fetchDeliveryPrice() {
      let elementQuery = new URLSearchParams();
      elementQuery.set('element_id', this.productId);
      elementQuery.set('location_code', this.currentLocationCode);

      return fetch(`/local/ajax/calculateDelivery.php?${elementQuery.toString()}`,
        {
          method: 'GET',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
        .then((response) => response.json())
        .then((jsonResult) => {
          if(!jsonResult.success) {
            throw new Error('Not success')
          }

          return jsonResult.data;
        });
    }
  },
  components: {
    'delivery-item': DeliveryItem,
    'jquery-dadata': JqueryDadata,
  },
}
</script>
